import React from "react";
import { FormattedMessage } from "react-intl";
import { Icon, ModalService } from "@sportal/cdk";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "../../../../../components/button/Button";
import { useSchedulerContext } from "../../SchedulerContext";
import { ScheduleRuleDialog } from "../scheduleRuleDialog/ScheduleRuleDialog";
import {
  addScheduleRule,
  getProfileSchedulesByType,
  isScheduleEnabled,
} from "../../../../../store/schedules";
import { Tooltip } from "../../../../../components/tooltip/Tooltip";
import _ from "lodash";

export const AddScheduleRuleButton = () => {
  const dispatch = useDispatch();
  const { profileId, weekdays, timeFormat24h, type, maxSchedulesCount } =
    useSchedulerContext();
  const currentRules = useSelector(getProfileSchedulesByType(profileId, type));
  const isEnabled = useSelector(isScheduleEnabled(profileId, type));
  const isLimitReached = currentRules.length >= maxSchedulesCount;

  const openDialog = () => {
    ModalService.show((modal) => ({
      dialog: (
        <ScheduleRuleDialog
          modal={modal}
          profileId={profileId}
          weekdays={weekdays}
          timeFormat24h={timeFormat24h}
          scheduleType={type}
        />
      ),
    }))
      .then((schedule) => {
        const enabled = _.isEmpty(currentRules) || isEnabled;
        dispatch(addScheduleRule({ ...schedule, enabled }));
      })
      .catch(() => {});
  };

  const AddRuleButton = () => (
    <Button
      disabled={isLimitReached}
      className={"schedule-rules__add-rule"}
      size={"medium"}
      color="secondary"
      iconLeft={<Icon icon="fa-solid fa-plus" />}
      onClick={openDialog}
      aria-describedby={"add-rule-description"}
    >
      <FormattedMessage id="add_rule" />
    </Button>
  );

  const AccessibilityDescription = () => {
    const messageId = isLimitReached
      ? `schedule_limit_reached_aria_${type}`
      : "";

    return (
      <span aria-hidden={true} hidden={true} id={"add-rule-description"}>
        {messageId && <FormattedMessage id={messageId} />}
      </span>
    );
  };

  return isLimitReached ? (
    <Tooltip
      placement={"left"}
      content={<FormattedMessage id="schedule_limit_reached_tooltip" />}
    >
      <AccessibilityDescription />
      <AddRuleButton />
    </Tooltip>
  ) : (
    <AddRuleButton />
  );
};
